<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">BRING IN</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
            <thead class="thead-light psticky">
                <tr>
                    <th scope="col" class="text-left">CUSTOMER <br>ACCOUNT | TYPE</th>
                    <th scope="col">BOUGHT</th>
                    <th scope="col">COST</th>

                    <!-- <th scope="col">COUPON</th> -->
                    <th scope="col">QTY</th>
                    <th scope="col">AVLB QTY</th>
                    <th 
                        scope="col" 
                        class="sort text-center"
                        >SELL QTY</th> 
                    <th 
                    scope="col" 
                    class="sort text-center"
                    >SPREAD</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(holding) in holding.bidWantedInventoryListDto" :key="holding.id"  >
                    <td class="text-left">
                        <span class="text-primary">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                        <span>{{holding.accountVal}}</span> | 
                        <span class="text-success">{{holding.accountType}}</span> 
                    </td>
                    <td class="text-center">
                        <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                    </td>
                    <td class="text-center"><span>{{holding.cost | currency}}</span></td>

                    <td class="text-center">
                        <span>{{holding.quantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span>{{holding.availableQuantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span>{{holding.sellQuantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <input style="width:65px" class="form-control" type="number"  @change="setSpread(holding.spread,holding.customerId)" v-model.number="holding.spread">
                    </td> 
                   
                </tr>    
                
            </tbody>
            </table> 
            <form  @submit.prevent="">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputLast">Price</label>
                        <input type="number" class="form-control" placeholder="Price"  v-model.number="holding.bringInPrice">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputLast">Note</label>
                        <textarea style="height:auto" class="form-control" v-model="note" rows="6"></textarea>
                    
                    </div>
                </div> 
                <div class="form-row">
                    
                </div>      
            </form>   
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button @click="bringIn()" type="button" class="btn btn-success" >BRING IN</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'bringin',
    props:['holding'],
    components :{
       
    },
    data() {
        return {
           note : "",
           loading : false,
           highBidPrice : null

        }

    },
    methods:{
        setSpread(spread,customerId){
            if(customerId){
                this.holding.bidWantedInventoryListDto.forEach((element) => {
                    if(element.customerId == customerId){
                        element.spread = spread
                    }
                });
            }
        },
        bringIn(){
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            let spreadDto = [];
            this.holding.bidWantedInventoryListDto.forEach((holding) =>{
                spreadDto.push({"inventoryId":holding.inventoryId,"spread":holding.spread})
            });
            var message = `Are you sure you want to bring in?`;
            var difference = Math.abs(Number(this.highBidPrice) - Number(this.holding.bringInPrice));
            if (difference > 2) {
                message = "The entered price varies by more than 2 points from the high bid price. Would you like to proceed?"
            }
            this.$confirm(message,"","question",{confirmButtonText:"BRING IN",cancelButtonText : "NO"}).then(() => {
                this.loading = true;
                this.$http
                    .post(
                    config.baseUrlBidSide +
                        "/bidwanted/bring-in",
                        {
                            "bidWantedId": this.holding.id,
                            "note": this.note,
                            "cognitoSub": authService.getUser().cognitoSub,
                            "spreadDto": spreadDto,
                            "bringInPrice":this.holding.bringInPrice,
                        },
                        auth
                    )
                    .then(() => {
                        this.loading = false;
                        this.$alert("Success","","success");
                        this.$emit('close');
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log(e);
                    });
            })
            }
    },
    mounted(){
        // this.holding.bringInPrice = this.holding.highBidPrice;
        this.holding.bidWantedBids.forEach(bid => {
            //if(bid.highBid){
                this.holding.bringInPrice = bid.bidPrice;
                this.highBidPrice = bid.bidPrice;
            //}
        });
        // console.log(this.holding)
    }
};
</script>
<style scoped>
.flex-container{
    display : flex;
    justify-content: space-between;
}
.flex-container > div{
    margin: 10px;
    text-align: left;
    font-weight: 500;
}
.data-value{
    color:rgb(10 139 213);
    font-weight: 500;
}
</style>